export const permanentAddressFields = [
  {
    id: "flat_no",
    label: "Flat/House No",
    type: "text",
    placeholder: "Enter flat/house no",
  },
  {
    id: "street",
    label: "Street",
    type: "text",
    placeholder: "Enter street",
  },
  {
    id: "city",
    label: "City",
    type: "text",
    placeholder: "Enter city",
  },
  {
    id: "country",
    label: "Country",
    type: "select",
    options: [],
  },
  {
    id: "state",
    label: "State",
    type: "select",
    options: [],
  },
  {
    id: "district",
    label: "District",
    type: "text",
    placeholder: "Enter district",
  },

  {
    id: "pin_code",
    label: "Pin Code",
    type: "text",
    placeholder: "Enter pin code",
  },
  {
    id: "phone_number",
    label: "Phone Number",
    type: "text",
    required: true,
    placeholder: "Enter phone number",
  },
];

export const presentAddressFields = [
  {
    id: "flat_no",
    label: "Flat/House No",
    type: "text",
    placeholder: "Enter flat/house no",
  },
  {
    id: "street",
    label: "Street",
    type: "text",
    placeholder: "Enter street",
  },
  {
    id: "city",
    label: "City",
    type: "text",
    placeholder: "Enter city",
  },
  {
    id: "country",
    label: "Country",
    type: "select",
    options: [],
  },
  {
    id: "state",
    label: "State",
    type: "select",
    options: [],
  },
  {
    id: "district",
    label: "District",
    type: "text",
    placeholder: "Enter district",
  },
  {
    id: "pin_code",
    label: "Pin Code",
    type: "text",
    placeholder: "Enter pin code",
  },
  {
    id: "phone_number",
    label: "Phone Number",
    type: "text",
    required: true,
    placeholder: "Enter phone number",
  },
];

export const personalInfoFields = [
  {
    id: "blood_group",
    label: "Blood Group",
    type: "select",
    options: ["A+", "A-", "B+","B-", "O+","O-","AB+","AB-"],
  },
  {
    id: "personal_email",
    label: "Personal Email",
    type: "email",
    required: true,
    placeholder: "priyasharma@email.com",
  },
  {
    id: "father_name",
    label: "Father Name",
    type: "text",
    placeholder: "Enter father name",
  },

  {
    id: "marital_status",
    label: "Marital Status",
    type: "select",
    options: ["Single", "Married","Divorced"],
  },
  {
    id: "marriage_date",
    label: "Marriage Date",
    type: "date",
  },
  {
    id: "spouse_name",
    label: "Spouse Name",
    type: "text",
  },

  {
    id: "country_of_origin",
    label: "Country of Origin",
    type: "select",
    options: ["India", "USA"],
  },
  {
    id: "nationality",
    label: "Nationality",
    type: "select",
    options: ["Indian", "American"],
  },
  {
    id: "is_international_employee",
    label: "International Employee",
    type: "select",
    options: ["Yes", "No"],
  },

  {
    id: "is_physically_challenged",
    label: "Physically Challenged",
    type: "select",
    options: ["Yes", "No"],
  },
  {
    id: "disability_type",
    label: "Disability Type",
    type: "select",
    options: ["Visual Impairment", "Hearing Impairment", "Physical Impairment", "Intellectual Impairment"],
  },
  {
    id: "gender",
    label: "Gender",
    type: "select",
    required: true,
    options: ["Male", "Female", "Other"],
  },

  {
    id: "date_of_birth",
    label: "Date of Birth",
    type: "date",
    required: true,
  },
];

export const employmentFields = [
  {
    id: "company_name",
    label: "Company Name",
    type: "text",
    placeholder: "Enter company name",
  },
  {
    id: "designation",
    label: "Designation",
    type: "text",
    placeholder: "Enter designation",
  },
  {
    id: "last_drawn_salary",
    label: "Last Drawn Salary",
    type: "number",
    placeholder: "Enter amount",
  },

  {
    id: "from_date",
    label: "From Date",
    type: "date",
    placeholder: "Select",
  },
  {
    id: "to_date",
    label: "To Date",
    type: "date",
    placeholder: "Select",
  },
  {
    id: "reason_for_leaving",
    label: "Reason for Leaving",
    type: "text",
    placeholder: "Enter reason",
  },

  {
    id: "company_address",
    label: "Company Address",
    type: "textarea",
    placeholder: "Enter company address",
  },
];

export const bankAccountFields = [
  {
    id: "bank_country",
    label: "Country",
    type: "select",
    options: [],
  },
  {
    id: "bank_account_number",
    label: "Bank Account Number",
    type: "text",
    placeholder: "Enter account number",
    required: true,
  },
  {
    id: "confirm_bank_account_number",
    label: "Confirm Bank Account Number",
    type: "text",
    placeholder: "Re-enter account number",
    required: true,
  },

  {
    id: "ifsc_code",
    label: "IFSC Code",
    type: "text",
    placeholder: "Enter ifsc code",
    required: true,
  },
  {
    id: "bank_account_name",
    label: "Name as per Bank Account",
    type: "text",
    required: true,
    placeholder: "Enter name",
  },
  {
    id: "account_type",
    label: "Account Type",
    type: "select",
    options: ["Savings", "Current", "Salary"],
    required: true,
  },
];

export const pfAccountFields = [
  {
    id: "previous_pf_account_number",
    label: "Previous PF Account Number",
    type: "text",
    placeholder: "Enter previous PF number",
  },
  {
    id: "uan",
    label: "UAN",
    type: "text",
    placeholder: "Enter UAN",
  },
];

export const panFields = [
  {
    id: "pan_number",
    label: "PAN Number",
    type: "text",
    required: true,
    placeholder: "Enter PAN number",
  },
  {
    id: "name_in_pan",
    label: "Name in PAN",
    type: "text",
    required: true,
    placeholder: "Enter name",
  },
];

export const aadhaarFields = [
  {
    id: "aadhaar_number",
    label: "Aadhaar Number",
    type: "text",
    required: true,
    placeholder: "Enter Aadhaar number",
  },
  {
    id: "name_in_aadhaar",
    label: "Name in Aadhaar",
    type: "text",
    required: true,
    placeholder: "Enter name",
  },
];

export const passportFields = [
  {
    id: "passport_number",
    label: "Passport Number",
    type: "text",
    placeholder: "Enter passport number",
  },
  {
    id: "name_in_passport",
    label: "Name in Passport",
    type: "text",
    placeholder: "Enter name as in passport",
  },
  {
    id: "passport_expiry_date",
    label: "Expiry Date",
    type: "date",
    placeholder: "Select",
  },
];

export const familyMemberFields = [
  {
    id: "name",
    label: "Name",
    type: "text",
    placeholder: "Enter name",
  },
  {
    id: "relationship",
    label: "Relationship",
    type: "select",
    options: [
      "father",
      "mother",
      "spouse",
      "son",
      "daughter",
      "brother",
      "sister",
      "guardian",
      "other",
    ],
  },
  {
    id: "date_of_birth",
    label: "Date of Birth",
    type: "date",
    placeholder: "Select",
  },
  {
    id: "gender",
    label: "Gender",
    type: "select",
    options: ["male", "female", "other"],
  },
  {
    id: "blood_group",
    label: "Blood Group",
    type: "select",
    options: ["A+", "A-", "B+", "B-", "O+", "O-", "AB+", "AB-"],
  },
  {
    id: "nationality",
    label: "Nationality",
    type: "select",
    options: ["Indian", "American", "Canadian", "British", "Other"],
  },
];

export const docTypeOptions = [
  { value: "aadhaar", label: "Aadhaar Card" },
  { value: "passport", label: "Passport" },
  { value: "pan", label: "PAN Card" },
  // { value: "experience_letter", label: "Experience Letter" },
];
